module.exports = __webpack_public_path__ + "img/Flag_of_Serbia.74b32a84.svg";